
export const createModel = () => {

	const data = {}
	const listeners = []

	const set = (key, val) => {
		data[key] = val
		updateListeners(key, val)
	}

	const clear = () => {
		for (const key in data) {
			delete data[key]
		}
		updateListeners(null, null)
	}

	const listAdd = (key, val) => {
		data[key] = data[key] || []
		data[key].push(val)
		updateListeners(key, data[key])
	}

	const listRemove = (key, val) => {
		const index = data[key].indexOf(val)
		if (index > -1) {
			data[key].splice(index, 1)
		}
		if (data[key].length === 0) {
			delete data[key]
		}
		updateListeners(key, data[key])
	}

	const listIncludes = (key, value) => {
		return data[key].indexOf(value) > -1
	}

	const updateListeners = (key, val) => {
		listeners.forEach(listener => {
			if (listener.key && listener.key === key) listener.callback(val, data)
			if (listener.key === undefined) listener.callback(key, val, data)
		})
	}

	const subscribe = (keyOrCallback, callback = undefined) => {
		if (typeof keyOrCallback === 'string' && typeof callback === 'function') 
			listeners.push({ key : keyOrCallback, callback })
		if (typeof keyOrCallback === 'function' && callback === undefined) 
			listeners.push({ key : undefined, callback : keyOrCallback })
	}

	return { 
		data : () => data, 
		set, 
		subscribe,
		listAdd, listRemove, listIncludes,
		clear
	}
}